import { type FC } from "react";

import { ScaleArt } from "./scale_art";

// Markup transcribed from the design port kit (sections/Scale.html).
export const Scale: FC = () => (
  <section className="stakes">
    <div className="wrap">
      <div className="stakegrid">
        <div>
          <h2>Built for any scale. HIPAA compliant.</h2>
          <p>
            One workbench for claim management, records optimization, and
            med-legal production. Bring any volume of records and get back the
            pertinent details: organized, cited, and ready to drive better
            medical-legal decisions.
          </p>
          <p className="seccure">
            Your records are encrypted, access-controlled, and HIPAA compliant.
          </p>
        </div>
        <ScaleArt />
      </div>
    </div>
  </section>
);
